import styled from "styled-components";
import { Table } from "antd";

export const Wrapper = styled(Table)`
  height: 100%;

  .ant-table table {
    text-align: center;
  }

  .ant-table-header th {
    background: #1a2138;
    color: white;
  }

  .ant-table-cell {
    color: #2a2a2a;
  }

  .ant-table-tbody > tr.ant-table-row:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background: #131f28;
    color: white !important;

    .login-button {
      background: #ffffff;
      color: black;
    }
  }

  .ant-table-thead > tr > th {
    background: #131f28 !important;
    color: #ffffff;
    border: 1px solid #ffffff;
    text-align: center;
    padding: 10px 30px;
    white-space: nowrap;
  }

  .ant-table-container table > thead > tr:first-child th:last-child {
    border-top-right-radius: 5px;
  }

  .ant-table-container table > thead > tr:first-child th:first-child {
    border-top-left-radius: 5px;
  }

  .ant-table-tbody > tr > td {
    font-size: 14px;
    border-bottom: none !important; /* Remove row lines */
  }

  .ant-table-title {
    border: none;
    font-size: 20px;
    text-align: center;
  }

  .ant-table {
    border: none;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 5px 10px;
    font-size: 16px;
    overflow: auto;
    table-layout: auto; /* Set table layout to auto */
    background: #F5F5F5;
  }

  .ant-space-item {
    color: #1a2138;
  }

  .login-button {
    padding: 5px 12px;
    width: 50%;
    font-size: 12px;
  }

  .header {
    text-align: center;
  }

  @media (max-width: 886px) {
    .ant-table-thead {
      width: 100%;
    }
    overflow-x: scroll;
  }
`;

export const Header = styled.div`
  border-radius: 6px;

  .header {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    align-items: center;
  }

  background: #131f28;
  border: none;
  color: white;

  .heading {
    margin: 0px;
    color: white;
  }

  .buttons {
    display: flex;
  }

  @media only screen and (max-width: 520px) {
    .header {
      flex-direction: column;
      align-items: flex-start;
    }
    .heading {
      margin-bottom: 10px;
    }
  }
`;
